// src/data/comedians/lucille-ball.js

const base = {
  id: 'lucille-ball',
  slug: 'lucille-ball',
  name: 'Lucille Ball',
  birthYear: 1911,
  image: require('@/assets/images/img_Lucille_Ball.png'),
  famousWorks: [
    'I Love Lucy (1951–1957)',
    'The Lucy Show (1962–1968)',
    "Here's Lucy (1968–1974)",
    'Desilu Productions founder',
    'Producer of Star Trek, Mission: Impossible',
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'American',
    shortBio: 'TV comedy pioneer and I Love Lucy star',
    bio: `Lucille Ball was an American actress, comedian, and producer who revolutionized television comedy. Best known for her iconic role as Lucy Ricardo in "I Love Lucy", she became one of the most beloved entertainers of the 20th century and a trailblazer for women in television production.\n\nBorn in Jamestown, New York, Ball began her career as a model and actress in the 1930s. With her husband Desi Arnaz, she created and starred in "I Love Lucy" (1951–1957), which became one of the most successful TV shows of all time.\n\nBall's physical comedy, impeccable timing, and expressive face made her a master of the sitcom format. Through Desilu Productions she also produced groundbreaking shows like "Star Trek" and "Mission: Impossible", making her one of the most powerful women in Hollywood history.`,
    style: 'Physical comedy, slapstick, expressive facial reactions, perfect timing',
    achievements: [
      'Four Emmy Awards',
      'Kennedy Center Honors',
      'Presidential Medal of Freedom',
      'First woman to head a major television production studio',
      'Hollywood Walk of Fame stars (TV, Film, Radio)',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Américaine',
    shortBio: 'Pionnière de la comédie télévisée et star de I Love Lucy',
    bio: `Lucille Ball était une actrice, comédienne et productrice américaine qui a révolutionné la comédie télévisée. Surtout connue pour son rôle emblématique de Lucy Ricardo dans "I Love Lucy", elle est devenue l'une des artistes les plus aimées du XXᵉ siècle et une pionnière pour les femmes dans la production télévisuelle.\n\nNée à Jamestown, New York, Ball débute sa carrière comme mannequin et actrice dans les années 1930. Avec son mari Desi Arnaz, elle crée et joue dans "I Love Lucy" (1951–1957), qui devient l'une des émissions les plus regardées de tous les temps.\n\nSa comédie physique, son timing parfait et son expressivité font d'elle une maîtresse du sitcom. Via Desilu Productions, elle a également produit des séries révolutionnaires comme "Star Trek" et "Mission: Impossible".`,
    style: 'Comédie physique, slapstick, expressions faciales expressives, timing parfait',
    achievements: [
      'Quatre Emmy Awards',
      'Kennedy Center Honors',
      'Médaille présidentielle de la Liberté',
      'Première femme à diriger un grand studio de production télévisuelle',
      'Étoiles sur le Hollywood Walk of Fame (TV, cinéma, radio)',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Americana',
    shortBio: 'Pionera de la comedia televisiva y estrella de I Love Lucy',
    bio: `Lucille Ball fue una actriz, comediante y productora estadounidense que revolucionó la comedia televisiva. Conocida sobre todo por su icónico papel de Lucy Ricardo en "I Love Lucy", se convirtió en una de las artistas más queridas del siglo XX y una pionera para las mujeres en la producción televisiva.\n\nNacida en Jamestown, Nueva York, Ball comenzó su carrera como modelo y actriz en los años 30. Con su esposo Desi Arnaz, creó y protagonizó "I Love Lucy" (1951–1957), que se convirtió en uno de los programas televisivos más exitosos de todos los tiempos.\n\nSu comedia física, timing impecable y expresividad la convirtieron en una maestra de la sitcom. A través de Desilu Productions también produjo programas revolucionarios como "Star Trek" y "Misión: Imposible".`,
    style: 'Comedia física, slapstick, reacciones faciales expresivas, timing perfecto',
    achievements: [
      'Cuatro Emmy Awards',
      'Kennedy Center Honors',
      'Medalla Presidencial de la Libertad',
      'Primera mujer en dirigir un importante estudio de producción televisiva',
      'Estrellas en el Paseo de la Fama de Hollywood (TV, cine, radio)',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'أمريكية',
    shortBio: 'رائدة الكوميديا التلفزيونية ونجمة I Love Lucy',
    bio: `لوسيل بول ممثلة وكوميدية ومنتجة أمريكية أحدثت ثورة في الكوميديا التلفزيونية. اشتُهرت بدورها الأيقوني في مسلسل "I Love Lucy" بشخصية لوسي ريكاردو، لتصبح واحدة من أكثر الفنانات محبةً في القرن العشرين ورائدة للمرأة في إنتاج التلفزيون.\n\nوُلدت في جيمستاون بنيويورك، وبدأت مسيرتها ممثلةً وعارضة أزياء في ثلاثينيات القرن الماضي. مع زوجها ديزي أرناز، ابتكرت وجسّدت بطولة "I Love Lucy" (1951–1957) الذي أصبح من أنجح البرامج التلفزيونية في التاريخ.\n\nجعلت كوميديا جسدية رفيعة، وتوقيت مثالي، وتعبير استثنائي منها سيدةً لا منازع لها في عالم المسلسلات الكوميدية. كما أنتجت عبر شركة Desilu Productions برامج بارزة من بينها "Star Trek" و"Mission: Impossible".`,
    style: 'كوميديا جسدية، سلاپستيك، تعابير وجه معبّرة، توقيت مثالي',
    achievements: [
      'أربع جوائز Emmy',
      'Kennedy Center Honors',
      'الميدالية الرئاسية للحرية',
      'أول امرأة تترأس استوديو إنتاج تلفزيوني كبرى',
      'نجمات على ممشى المشاهير في هوليوود (تلفزيون وسينما وراديو)',
    ],
  },
];
